import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ClashList component
 * Provides loading, empty state, and content container styling
 */
export const useClashListStyles = makeStyles((theme: Theme) => ({
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(4),
    },
    loadingText: {
        marginTop: theme.spacing(2),
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
    content: {
        marginTop: theme.spacing(2),
    },
}))
